(function () {
  'use strict';
  function eligible(product) {
    if (!product || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(product.handle || '') || !product.title) return false;
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    if (tags.some(function (tag) { return /^(gift[ -]only|membership)$/i.test(String(tag).trim()); })) return false;
    if (/complimentary-gift|membership|gift-card/i.test(product.handle)) return false;
    if (!Array.isArray(product.variants) || !product.variants.some(function (v) { return v.available === true && v.requires_shipping === true; })) return false;
    try { return new URL(product.images[0].src).protocol === 'https:'; } catch (error) { return false; }
  }
  function select(products, count, random) {
    var seen = new Set();
    var pool = products.filter(function (p) {
      if (!eligible(p) || seen.has(p.handle)) return false;
      seen.add(p.handle); return true;
    });
    var rng = random || Math.random;
    for (var i = pool.length - 1; i > 0; i -= 1) {
      var j = Math.floor(rng() * (i + 1));
      var item = pool[i]; pool[i] = pool[j]; pool[j] = item;
    }
    return pool.slice(0, count);
  }
  async function loadAll(loadPage) {
    var products = [], seen = new Set();
    for (var page = 1; page <= 100; page += 1) {
      var payload = await loadPage(page, 250);
      if (!payload || !Array.isArray(payload.products)) throw new Error('Invalid catalog response');
      var signature = payload.products.map(function (p) { return p.handle; }).join('|');
      if (payload.products.length && seen.has(signature)) throw new Error('Repeated catalog page');
      seen.add(signature);
      products.push.apply(products, payload.products);
      if (payload.products.length < 250) return products;
    }
    throw new Error('Catalog exceeds safe page limit');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { select: select, loadAll: loadAll };
  if (typeof document === 'undefined') return;
  var catalog;
  function readCatalog(endpoint) {
    if (!catalog) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      catalog = loadAll(async function (page, size) {
        var url = new URL(endpoint, location.origin);
        if (url.origin !== location.origin || !url.pathname.endsWith('/collections/all/products.json')) throw new Error('Invalid catalog URL');
        url.searchParams.set('limit', size); url.searchParams.set('page', page);
        var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Catalog unavailable');
        return response.json();
      }).finally(function () { clearTimeout(timer); });
    }
    return catalog;
  }
  function createTile(product, root) {
    var link = document.createElement('a');
    link.href = root.dataset.productBase + product.handle;
    link.className = 'pk-product-wall__tile';
    link.setAttribute('aria-label', product.title);
    var img = document.createElement('img');
    var src = new URL(product.images[0].src); src.searchParams.set('width', '600');
    img.src = src.href; img.alt = product.title; img.width = 600; img.height = 600;
    img.decoding = 'async'; img.loading = 'lazy';
    link.appendChild(img);
    var prices = product.variants.map(function (variant) { return Math.round(Number(variant.price) * 100); }).filter(Number.isFinite);
    if (prices.length) {
      var amount = Math.min.apply(Math, prices);
      var price = document.createElement('span'); price.className = 'pk-product-wall__price';
      var money = function (cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'}).format(cents / 100); };
      var prefix = new Set(prices).size > 1 ? 'From ' : '';
      if (window.PKOpeningSale) window.PKOpeningSale.renderPrice(price, product, amount, money, prefix);
      else price.textContent = prefix + money(amount);
      link.appendChild(price);
    }
    img.addEventListener('error', function () {
      var fallback = root._wallFallback && root._wallFallback.find(function (a) {
        return !Array.from(root.children).some(function (tile) { return tile.href === a.href; });
      });
      if (fallback && link.isConnected) {
        var restored = fallback.cloneNode(true);
        if (window.PKOpeningSale && !window.PKOpeningSale.active()) restored.querySelectorAll('[data-pk-sale-price]').forEach(function (price) {
          price.textContent = price.dataset.pkBaseText || '';
          price.classList.remove('pk-sale-amount', 'price--on-sale');
          price.removeAttribute('data-pk-sale-price');
        });
        link.replaceWith(restored);
      }
    }, { once: true });
    return link;
  }
  async function initialize(root) {
    if (root.dataset.wallState) return;
    root.dataset.wallState = 'loading';
    try {
      var products = await readCatalog(root.dataset.catalog);
      var queue = select(products, products.length);
      var chosen = queue.splice(0, 10);
      if (!root.isConnected || chosen.length < 10 || root.contains(document.activeElement)) {
        root.dataset.wallState = 'fallback'; return;
      }
      root._wallFallback = Array.from(root.children);
      var fragment = document.createDocumentFragment();
      chosen.forEach(function (p) { fragment.appendChild(createTile(p, root)); });
      root.replaceChildren(fragment);
      root.dataset.wallState = 'ready';
      root.dataset.poolSize = products.length;
      var section = root.closest('[data-pk-wall-section]');
      if (!section) return;
      var more = section.querySelector('[data-pk-wall-more]');
      var status = section.querySelector('[data-pk-wall-status]');
      var browse = section.querySelector('[data-pk-wall-browse]');
      function remaining() {
        var displayed = new Set(Array.from(root.children).map(function (a) { return a.getAttribute('href'); }));
        queue = queue.filter(function (p) { return !displayed.has(root.dataset.productBase + p.handle); });
        more.hidden = queue.length === 0;
        if (!queue.length) status.textContent = status.dataset.complete;
      }
      if (more && status) {
        if (browse) browse.hidden = true;
        remaining();
        more.addEventListener('click', function (event) {
          remaining();
          var batch = queue.splice(0, 10), fragment = document.createDocumentFragment(), first;
          batch.forEach(function (p) { var tile = createTile(p, root); if (!first) first = tile; fragment.appendChild(tile); });
          root.appendChild(fragment);
          status.textContent = status.dataset.added;
          remaining();
          if (first && event.detail === 0) first.focus({ preventScroll: true });
        });
      }
    } catch (error) { root.dataset.wallState = 'fallback'; }
  }
  var observed = new WeakSet();
  function prepare(root) {
    if (observed.has(root)) return;
    observed.add(root);
    if (typeof IntersectionObserver === 'undefined') { initialize(root); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      initialize(root);
    }, { rootMargin: '800px 0px' });
    observer.observe(root);
  }
  function init(target) { target.querySelectorAll('[data-pk-product-wall]').forEach(prepare); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
